import apiInstance from '@api/index';
import { clearTermsAgreement } from '@pages/TermsAgreement/store/actions';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { setGlobalCurrency } from '@store/global/globalSlice';

import { AuthApiResponse, LoginPayload } from 'types/authTypes';

export const login = createAsyncThunk<
  AuthApiResponse,
  LoginPayload,
  { rejectValue: string }
>('auth/login', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.auth.login(payload);
    return response.data;
  } catch (error: any) {
    // A 403 carries a message meant for the user (expired temporary password or free trial)
    const message =
      error.response?.status === 403
        ? error.response?.data?.message
        : undefined;
    return rejectWithValue(message || 'Login Failed');
  }
});

export const logout = createAsyncThunk<
  { message: string },
  void,
  { rejectValue: string }
>('auth/logout', async (_, { rejectWithValue, dispatch }) => {
  try {
    dispatch(clearTermsAgreement());
    const response = await apiInstance.auth.logout();
    return { message: response.data.message };
  } catch (error: any) {
    return rejectWithValue(
      error.message || error.response?.data?.message || 'Logout failed',
    );
  }
});

export const verifySession = createAsyncThunk<
  AuthApiResponse,
  void,
  { rejectValue: string }
>('auth/verifySession', async (_, { rejectWithValue, dispatch }) => {
  try {
    const response = await apiInstance.auth.verifySession();
    // Without a session the backend answers 200 with user null (e.g. right after logout)
    if (response.data.user) {
      dispatch(
        setGlobalCurrency({ value: response.data.user.currencyId, label: '' }),
      );
    }

    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message || 'Session verification failed');
  }
});
